var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mySlider",staticClass:"slider"},[_c('div',{staticClass:"left-btn",class:{active:_vm.myPosition.isBtn==2}}),_vm._v(" "),_c('div',{staticClass:"propo"}),_vm._v(" "),_c('div',{staticClass:"propo-bg"}),_vm._v(" "),_c('div',{staticClass:"right-btn",class:{active:_vm.myPosition.isBtn==1}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10ba9e62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/container/slider.vue
// module id = null
// module chunks = 